import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'

export default createUseStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '1px',
    backgroundColor: theme.palette.grey[300],
  },
}))
